"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseTextShadowCompound = exports.parseBoxShadowCompound = void 0;
var css_data_types_1 = require("../../css-data-types");
var shorthands_1 = require("../../shorthands");
var compound_parser_utils_1 = require("../compound-parser-utils");
var compound_value_parsers_1 = require("../compound-value-parsers");
// box-shadow
var parseBoxShadowCompound = function () {
    return (0, compound_parser_utils_1.createCompoundParser)({
        prop: 'box-shadow',
        singleKeywordPart: {
            prop: 'box-shadow',
            dataType: css_data_types_1.shadowSingleValueDataType,
            parser: compound_value_parsers_1.identityCompoundValueParser,
        },
        parts: [
            { prop: 'inset', dataType: css_data_types_1.insetDataType, parser: (0, compound_value_parsers_1.keywordsCompoundValueParser)(css_data_types_1.INSET_KEYWORD) },
            { prop: 'offset-x', dataType: css_data_types_1.lengthDataType, parser: compound_value_parsers_1.dimensionCompoundValueParser, mandatory: true },
            { prop: 'offset-y', dataType: css_data_types_1.lengthDataType, parser: compound_value_parsers_1.dimensionCompoundValueParser, mandatory: true },
            { prop: 'blur-radius', dataType: css_data_types_1.lengthDataType, parser: compound_value_parsers_1.dimensionCompoundValueParser },
            { prop: 'spread-radius', dataType: css_data_types_1.lengthDataType, parser: compound_value_parsers_1.dimensionCompoundValueParser },
            { prop: 'color', dataType: css_data_types_1.colorDataType, parser: compound_value_parsers_1.identityCompoundValueParser },
        ],
        shorthandOpener: function (astNodes, api, parts) {
            return (0, shorthands_1.layersShorthandOpener)('box-shadow', (0, shorthands_1.unorderedListShorthandOpener)(parts), parts)(astNodes, api);
        },
    });
};
exports.parseBoxShadowCompound = parseBoxShadowCompound;
// text-shadow
var parseTextShadowCompound = function () {
    return (0, compound_parser_utils_1.createCompoundParser)({
        prop: 'text-shadow',
        singleKeywordPart: {
            prop: 'text-shadow',
            dataType: css_data_types_1.shadowSingleValueDataType,
            parser: compound_value_parsers_1.identityCompoundValueParser,
        },
        parts: [
            { prop: 'offset-x', dataType: css_data_types_1.lengthDataType, parser: compound_value_parsers_1.dimensionCompoundValueParser, mandatory: true },
            { prop: 'offset-y', dataType: css_data_types_1.lengthDataType, parser: compound_value_parsers_1.dimensionCompoundValueParser, mandatory: true },
            { prop: 'blur-radius', dataType: css_data_types_1.lengthDataType, parser: compound_value_parsers_1.dimensionCompoundValueParser },
            { prop: 'color', dataType: css_data_types_1.colorDataType, parser: function (text) { return text; } },
        ],
        shorthandOpener: function (astNodes, api, parts) {
            return (0, shorthands_1.layersShorthandOpener)('text-shadow', (0, shorthands_1.unorderedListShorthandOpener)(parts), parts)(astNodes, api);
        },
    });
};
exports.parseTextShadowCompound = parseTextShadowCompound;
//# sourceMappingURL=shadow-compound.js.map